import { useEffect } from "react";
import { Typography } from "kosmos-ui";

import { useLayout } from "app/context/LayoutContext/hooks";

import {
  HomeIntroContainer,
  HomeIntroHeader,
  getHomeIntroHeaderStyles,
} from "./styles";
import gradientWaves from "./gradient.js";
import "./gradient.css";

export default function HomeIntro() {
  const { mobile, topbarHeight, announcementBarHeight } = useLayout();

  useEffect(() => {
    gradientWaves();
  }, []);

  const homeIntroHeaderStyles = getHomeIntroHeaderStyles({ mobile });

  const headerHeight = topbarHeight + announcementBarHeight;

  return (
    <HomeIntroContainer
      headerHeight={headerHeight}
      style={{
        minHeight: `calc(50vh - ${4 * topbarHeight}px + 144px)`,
      }}
    >
      <HomeIntroHeader>
        <Typography as="h1" variant="title1" style={homeIntroHeaderStyles}>
          Piensa independiente, <br /> con marcas independientes.
        </Typography>

        <canvas
          id="gradient-canvas"
          style={{
            minHeight: `calc(50vh - ${2 * topbarHeight}px + 144px)`,
            height: !mobile ? "100%" : "50vh",
            maxHeight: 440,
          }}
          data-js-darken-top
          data-transition-in
        />
      </HomeIntroHeader>
    </HomeIntroContainer>
  );
}
